module.exports = __webpack_public_path__ + "img/culture.17a8442d.png";